import React, { useEffect, useRef, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import {
  faAngleRight,
  faEye,
  faEyeSlash,
  faPlug,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Organisation_Offcan.css";
import Blue_Btn from "../../../../common/common_btn/blue_btn/Blue_Btn";
import Common_Back_Btn from "../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { useForm } from "react-hook-form";
import Gray_Btn from "../../../../common/common_btn/gray_btn/Gray_Btn";
import PasswordChecklist from "react-password-checklist";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAppSetup,
  UpdateAppSetUp,
} from "../../../../features/admin/Profile/Slice";
import Success_Toster from "../../../../common/common_modal/success_toster/Success_Toster";

const Organisation_Offcan = ({ show, handleClose }) => {
  const fileInputRef = useRef(null);
  const [profileImg, setProfileImg] = useState(
    "/assets/images/header/profile/user1.png",
  );

  const [isEdit, setIsEdit] = useState();

  const handlePlusClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Only images
    if (!file.type.startsWith("image/")) return;

    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setProfileImg(previewUrl);
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
    setError,
    getValues,
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEye);
  const [iconTwo, setIconTwo] = useState(faEye);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const dispatch = useDispatch();
  const footerFile = watch("footer_image");
  const headerFile = watch("header_image");
  const cerfooterFile = watch("cer_footer_image");
  const cerheaderFile = watch("cer_header_image");
  const logoFile = watch("logo");
  const certificate1 = watch("certificate_laboratory");
  const certificate2 = watch("certificate_nabl");

  const signatureFile = watch("signature");

  const appsetup = useSelector((state) => state.profile.appsetup_data);
  useEffect(() => {
    dispatch(GetAppSetup());
  }, [dispatch]);



  useEffect(() => {
    reset(appsetup);
  }, [appsetup]);
  const [success, setSuccess] = useState(false);
  const onSubmit = async (data) => {
    // console.log(data,"data ")
    try {
      const formData = new FormData();

      // -------- BASIC INFO --------
      formData.append("organizational_name", data.organizational_name);
      formData.append("registered_address", data.registered_address);
      formData.append("contact_no", data.contact_no);
      formData.append("email", data.email);

      // -------- LEGAL INFO --------
      formData.append("gst_no", data.gst_no);
      formData.append("pan_no", data.pan_no);
      formData.append("cin_no", data.cin_no);
      formData.append("nabl_number", data.nabl_number);

      // -------- BANK DETAILS --------
      formData.append("account_type", data.account_type);
      formData.append("account_no", data.account_no);
      formData.append("micr", data.micr);
      formData.append("ifsc_code", data.ifsc_code);
      formData.append("branch_name", data.branch_name);
      formData.append("branch_code", data.branch_code);
      formData.append("bank_name", data.bank_name);
      formData.append("gst_percentage", data.gst_percentage);
      formData.append("tc_number", data.tc_number);
      formData.append("personal_link", data.personal_link);

      // -------- IMAGES --------
      if (data.header_image?.[0]) {
        formData.append("header_image", data.header_image[0]);
      }

      if (data.footer_image?.[0]) {
        formData.append("footer_image", data.footer_image[0]);
      }

      if (data.cer_header_image?.[0]) {
        formData.append("cer_header_image", data.cer_header_image[0]);
      }

      if (data.cer_footer_image?.[0]) {
        formData.append("cer_footer_image", data.cer_footer_image[0]);
      }

      if (data.logo?.[0]) {
        formData.append("logo", data.logo[0]);
      }
      if (data.signature?.[0]) {
        formData.append("signature", data.signature[0]);
      }
      if (data.certificate_laboratory?.[0]) {
        formData.append("certificate_laboratory", data.certificate_laboratory[0]);
      }
      if (data.certificate_nabl?.[0]) {
        formData.append("certificate_nabl", data.certificate_nabl[0]);
      }
      const res = await dispatch(UpdateAppSetUp({ data: formData }));



      if (res.meta.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAppSetup());
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 2000);
      } else {
        // setShowError(res.payload.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Offcanvas
      className="Organisation_Offcan common_offcanvas Profile_Offcanvas Account_Setting_Offcan"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn backText="Organization Details" />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="body_div">
          <>
            <Form
              className="add_form all_tabs_holder"
              onSubmit={handleSubmit(onSubmit)}
            >
              {/* ---------------- BASIC INFORMATION ---------------- */}
              <div className="white_box">
                <p className="form_section_title">Basic Information:</p>

                {/* Organization Name */}
                <Form.Group className="form_group">
                  <Form.Label>Organization Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Organization Name"
                    {...register("organizational_name", {
                      required: "Organization name is required",
                    })}
                  />
                  {errors?.organizational_name && (
                    <Form.Text className="text-danger">
                      {errors.organizational_name.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* Registered Address */}
                <Form.Group className="form_group">
                  <Form.Label>Registered Address / Lab Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Registered Address"
                    {...register("registered_address", {
                      required: "Registered address is required",
                    })}
                  />
                  {errors?.registered_address && (
                    <Form.Text className="text-danger">
                      {errors.registered_address.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <div className="row">
                  {/* Contact Number */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Contact Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Contact Number"
                        {...register("contact_no", {
                          required: "Contact number is required",
                          pattern: {
                            value: /^[6-9]\d{9}$/,
                            message: "valid 10 digit mobile number",
                          },
                        })}
                      />
                      {errors?.contact_no && (
                        <Form.Text className="text-danger">
                          {errors.contact_no.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* Email */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Official Email ID</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Email ID"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^\S+@\S+$/i,
                            message: "valid email",
                          },
                        })}
                      />
                      {errors?.email && (
                        <Form.Text className="text-danger">
                          {errors.email.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                </div>
              </div>

              {/* ---------------- LEGAL INFORMATION ---------------- */}
              <div className="gray_input_box">
                <p className="form_section_title">
                  Legal & Compliance Information:
                </p>

                <div className="row">
                  {/* GST Number */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>GST Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="GST Number"
                        {...register("gst_no", {
                          required: "GST number is required",
                          pattern: {
                            value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
                            message: "valid GST number",
                          },
                        })}
                      />
                      {errors?.gst_no && (
                        <Form.Text className="text-danger">
                          {errors.gst_no.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* PAN Number */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>PAN Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="PAN Number"
                        {...register("pan_no", {
                          required: "PAN number is required",
                          pattern: {
                            value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                            message: "valid PAN number",
                          },
                        })}
                      />
                      {errors?.pan_no && (
                        <Form.Text className="text-danger">
                          {errors.pan_no.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                </div>

                {/* CIN */}
                <Form.Group className="form_group">
                  <Form.Label>CIN Number (If Company Is Registered)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter CIN Number"
                    {...register("cin_no", {
                      required: "CIN Number is required",
                      minLength: {
                        value: 21,
                        message: "CIN must be 21 characters long",
                      },
                      maxLength: {
                        value: 21,
                        message: "CIN must be 21 characters long",
                      },
                      pattern: {
                        value: /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/i,
                        message: "Invalid CIN format",
                      },
                    })}
                  />
                  {errors.cin_no && (
                    <span className="text-danger">{errors.cin_no.message}</span>
                  )}
                </Form.Group>

                {/* NABL */}
                <Form.Group className="form_group">
                  <Form.Label>NABL Accreditation Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="NABL Accreditation Number"
                    {...register("nabl_number")}
                  />
                </Form.Group>
              </div>

              {/* ---------------- BANK DETAILS ---------------- */}
              <div className="white_box pb-3">
                <p className="form_section_title">Bank Details</p>

                <div className="row">
                  {/* Account Type */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Account Type</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Account Type"
                        {...register("account_type", {
                          required: "Account type is required",
                        })}
                      />
                      {errors?.account_type && (
                        <Form.Text className="text-danger">
                          {errors.account_type.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* Account Number */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Account Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Account Number"
                        {...register("account_no", {
                          required: "Account number is required",
                          minLength: {
                            value: 9,
                            message: "Account number must be at least 9 digits",
                          },
                          maxLength: {
                            value: 18,
                            message: "Account number must be at most 18 digits",
                          },
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Account number must contain only digits",
                          },
                        })}
                      />
                      {errors?.account_no && (
                        <Form.Text className="text-danger">
                          {errors.account_no.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* MICR */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>MICR Code</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter MICR Code"
                        {...register("micr", {
                          required: "MICR code is required",
                          minLength: {
                            value: 9,
                            message: "MICR code must be exactly 9 digits",
                          },
                          maxLength: {
                            value: 9,
                            message: "MICR code must be exactly 9 digits",
                          },
                          pattern: {
                            value: /^[0-9]{9}$/,
                            message: "MICR code must contain only digits",
                          },
                        })}
                      />
                      {errors?.micr && (
                        <Form.Text className="text-danger">
                          {errors.micr.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* IFSC */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>IFSC Code</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="IFSC Code"
                        {...register("ifsc_code", {
                          required: "IFSC code is required",
                          pattern: {
                            value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                            message: "valid IFSC code",
                          },
                        })}
                      />
                      {errors?.ifsc_code && (
                        <Form.Text className="text-danger">
                          {errors.ifsc_code.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* Branch Name */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Branch Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Branch Name"
                        {...register("branch_name", {
                          required: "Branch Name is required",
                        })}
                      />
                      {errors?.branch_name && (
                        <Form.Text className="text-danger">
                          {errors.branch_name.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* Branch Code */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Branch Code</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Branch Code"
                        {...register("branch_code", {
                          required: "Branch code is required",
                          pattern: {
                            value: /^[A-Za-z0-9]{6}$/,
                            message:
                              "Branch code must be alphanumeric (6 characters)",
                          },
                        })}
                        maxLength={6} // optional, prevents typing more than 6 chars
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^A-Za-z0-9]/g,
                            "",
                          );
                        }}
                      />
                      {errors?.branch_code && (
                        <Form.Text className="text-danger">
                          {errors.branch_code.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* Bank Name */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Bank Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Bank Name"
                        {...register("bank_name", {
                          required: "Bank Name is required",
                        })}
                      />
                      {errors?.bank_name && (
                        <Form.Text className="text-danger">
                          {errors.bank_name.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* GST Percentage */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>GST Percentage</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter GST Percentage"
                        {...register("gst_percentage", {
                          required: "GST Percentage is required",
                        })}
                        onKeyDown={(e) => {
                          const value = e.target.value;

                          // Allow control keys
                          if (
                            [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ].includes(e.key)
                          ) {
                            return;
                          }

                          // Allow numbers
                          if (/^[0-9]$/.test(e.key)) {
                            return;
                          }

                          // // Allow ONE decimal point
                          // if (e.key === "." && !value.includes(".")) {
                          //   return;
                          // }

                          // Block everything else
                          e.preventDefault();
                        }}
                      />
                      {errors?.gst_percentage && (
                        <Form.Text className="text-danger">
                          {errors.gst_percentage.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>TC Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter TC Number"
                        {...register("tc_number", {
                          required: "TC Number is required",
                        })}
                      />
                      {errors?.tc_number && (
                        <Form.Text className="text-danger">
                          {errors.tc_number.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Personal Link</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Personal Link"
                        {...register("personal_link", {
                          required: "Personal Link is required",
                        })}
                      />
                      {errors?.personal_link && (
                        <Form.Text className="text-danger">
                          {errors.personal_link.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Header Image</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("header_image", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("header_image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL +
                            getValues("header_image")
                          }
                          alt="Preview"
                          className="image-preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    ) : (
                      headerFile &&
                      headerFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(headerFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>

                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Footer Image</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("footer_image", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("footer_image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL +
                            getValues("footer_image")
                          }
                          alt="Preview"
                          className="image-preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    ) : (
                      footerFile &&
                      footerFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(footerFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>certificate Header Image</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("cer_header_image", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("cer_header_image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL +
                            getValues("cer_header_image")
                          }
                          alt="Preview"
                          className="image-preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    ) : (
                      cerheaderFile &&
                      cerheaderFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(cerheaderFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>

                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Certificate Footer Image</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("cer_footer_image", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("cer_footer_image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL +
                            getValues("cer_footer_image")
                          }
                          alt="Preview"
                          className="image-preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    ) : (
                      cerfooterFile &&
                      cerfooterFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(cerfooterFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>

                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Seal Image</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("logo", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("logo") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL + getValues("logo")
                          }
                          alt="Preview"
                          className="image-preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    ) : (
                      logoFile &&
                      logoFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(logoFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>

                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Signature Image</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("signature", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("signature") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={
                            process.env.REACT_APP_IMG_URL +
                            getValues("signature")
                          }
                          alt="Preview"
                          className="image-preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    ) : (
                      signatureFile &&
                      signatureFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(signatureFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>

                  {/* certificate_libroratory  */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Certificate 1</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("certificate_laboratory", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png, .pdf"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-lg-6">
                    <Form.Label>Document Preview</Form.Label>

                    {typeof getValues("certificate_laboratory") === "string" ? (
                      <div className="image-preview-container">
                        {/* Check if saved file is a PDF */}
                        {getValues("certificate_laboratory")?.toLowerCase().endsWith(".pdf") ? (
                          <iframe
                            src={process.env.REACT_APP_IMG_URL + getValues("certificate_laboratory")}
                            title="PDF Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              border: "1px solid #ddd",
                            }}
                          ></iframe>
                        ) : (
                          /* Saved image preview */
                          <img
                            src={process.env.REACT_APP_IMG_URL + getValues("certificate_laboratory")}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      certificate1 &&
                      certificate1?.length > 0 && (
                        <div className="image-preview-container">
                          {/* Uploaded file is PDF */}
                          {certificate1[0].type === "application/pdf" ? (
                            <iframe
                              src={URL.createObjectURL(certificate1[0])}
                              title="PDF Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                border: "1px solid #ddd",
                              }}
                            ></iframe>
                          ) : (
                            /* Uploaded image preview */
                            <img
                              src={URL.createObjectURL(certificate1[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                                border: "1px solid #ddd",
                              }}
                            />
                          )}
                        </div>
                      )
                    )}
                  </div>

                  {/* certificate_nabl  */}
                  <div className="col-lg-6">
                    <Form.Group className="form_group">
                      <Form.Label>Certificate 2</Form.Label>
                      <Form.Control
                        type="file"
                        {...register("certificate_nabl", {
                          // validate: async (value) => {
                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg"];
                          //     const fileType = value[0].name?.split(".")[1];
                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (
                          //       sizes.width !== 420 &&
                          //       sizes.height !== 520
                          //     ) {
                          //       return "Image width and height must be 420 px and 520 px";
                          //     }
                          //     const fileSize = Math.round(
                          //       value[0].size / 1024
                          //     );
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }
                          //   }
                          // },
                        })}
                        accept=".jpg, .jpeg, .png, .pdf"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-lg-6">
                    <Form.Label>Document 2 Preview </Form.Label>

                    {typeof getValues("certificate_nabl") === "string" ? (
                      <div className="image-preview-container">
                        {/* If saved value is a PDF */}
                        {getValues("certificate_nabl")?.toLowerCase().endsWith(".pdf") ? (
                          <iframe
                            src={process.env.REACT_APP_IMG_URL + getValues("certificate_nabl")}
                            title="PDF Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              border: "1px solid #ddd",
                            }}
                          ></iframe>
                        ) : (
                          /* If saved value is an image */
                          <img
                            src={process.env.REACT_APP_IMG_URL + getValues("certificate_nabl")}
                            alt="Preview"
                            className="image-preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              border: "1px solid #ddd",
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      certificate2 &&
                      certificate2?.length > 0 && (
                        <div className="image-preview-container">
                          {/* If uploaded file is PDF */}
                          {certificate2[0].type === "application/pdf" ? (
                            <iframe
                              src={URL.createObjectURL(certificate2[0])}
                              title="PDF Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                border: "1px solid #ddd",
                              }}
                            ></iframe>
                          ) : (
                            /* If uploaded file is image */
                            <img
                              src={URL.createObjectURL(certificate2[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                                border: "1px solid #ddd",
                              }}
                            />
                          )}
                        </div>
                      )
                    )}
                  </div>





                </div>
              </div>

              {/* Submit */}
              <div className="offcanvas_footer">
                <div className="btn_div">
                  <Gray_Btn type="submit" btnText="Submit" />
                </div>
              </div>
            </Form>
          </>
        </div>
      </Offcanvas.Body>
      {success && (
        <Success_Toster successText="App Setup Updated Successfully!" />
      )}
    </Offcanvas>
  );
};

export default Organisation_Offcan;
